import { coreUrls } from '@/api/urls/core';

import { formatStringByKey } from '@/utilities/formatStringByKey';
import { setApiOptions } from '@/utilities/services';

import { RequestResponseType } from '../../../../models';
import { PaginatedResponse } from '../../models';
import { GetVehiclesResponseType, GetVehiclesServiceQueryParamType, VehicleFullDetailsObject } from './models';

import { api } from '@/api/client';
import { AxiosPromise } from 'axios';

export const getVehiclesService = (queryParam: GetVehiclesServiceQueryParamType): AxiosPromise<PaginatedResponse<GetVehiclesResponseType>> => {
    const options = setApiOptions(coreUrls.getVehicles, {
        queryParam
    });
    return api({ ...options, method: 'GET' });
};

export const getVehicleBySlug = (slug: string): AxiosPromise<RequestResponseType<VehicleFullDetailsObject>> => {
    const options = setApiOptions(
        formatStringByKey(coreUrls.getVehicleBySlug, {
            slug
        })
    );
    return api({ ...options, method: 'GET' });
};
